import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FeatureFlagsModule } from '../core/feature-flags/feature-flags.module';
import { FooterComponent } from './footer/footer.component';

@NgModule({
  declarations: [FooterComponent],
  imports: [CommonModule, FeatureFlagsModule, RouterModule],
})
export class FooterModule {}
